import { IndexFiltersProps } from '@shopify/polaris';

export const sortOptions: IndexFiltersProps['sortOptions'] = [
  { label: 'Date', value: 'createdAt asc', directionLabel: 'Ascending' },
  { label: 'Date', value: 'createdAt desc', directionLabel: 'Descending' },
  { label: 'Order number', value: 'orderName asc', directionLabel: 'Ascending' },
  { label: 'Order number', value: 'orderName desc', directionLabel: 'Descending' },
  { label: 'Processing time', value: 'fulfilledProcessTime asc', directionLabel: 'Ascending' },
  { label: 'Processing time', value: 'fulfilledProcessTime desc', directionLabel: 'Descending' },
  { label: 'Dispatch lead time', value: 'dispatchLeadTime asc', directionLabel: 'Ascending' },
  { label: 'Dispatch lead time', value: 'dispatchLeadTime desc', directionLabel: 'Descending' },
  { label: 'Delivery time', value: 'deliveryTime asc', directionLabel: 'Ascending' },
  { label: 'Delivery time', value: 'deliveryTime desc', directionLabel: 'Descending' },
];
